import styled from '@emotion/styled';
import { responsiveFontSize } from '@presentation/styles';

export const Content = styled.div`
  .categories {
    padding: 10px 0 30px 0;
    justify-content: center;
  }

  img {
    max-width: 100%;
    margin: 15px 0;
  }

  h1 {
    ${responsiveFontSize(40, 3)}
    text-align: center;
    margin-bottom: 40px;
    font-family: ${(props) => props.theme.font.alternate};
    font-weight: 600;
  }

  h2,
  h3,
  h4 {
    font-weight: bold;
    margin-bottom: 20px;
    margin-top: 30px;
    font-weight: 600;
  }

  h2 {
    ${responsiveFontSize(25)}
  }

  h3 {
    ${responsiveFontSize(22)}
  }

  h4 {
    ${responsiveFontSize(18)}
  }

  i,
  em {
    font-style: italic;
  }

  b,
  strong {
    font-weight: bold;
  }

  a {
    color: ${(props) => props.theme.color.blue.default};
    padding-bottom: 1px;

    &:hover {
      cursor: pointer;

      padding-bottom: 0px;
      border-bottom: 1px solid ${(props) => props.theme.color.blue.default};
    }
  }

  ul {
    list-style: circle !important;
  }

  ol {
    list-style: decimal !important;
  }

  ul,
  ol {
    margin-bottom: 20px;
    padding-left: 25px;

    li {
      padding-left: 8px;
      margin-bottom: 5px;
    }
  }

  * {
    font-family: ${(props) => props.theme.font.default} !important;
  }

  .title {
    margin-bottom: 10px;
  }

  figure {
    overflow: auto;
    max-width: 800px;
    margin: auto;
  }
  table {
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.07);
    margin: 15px auto;
    tr {
      white-space: nowrap;
      border-bottom: 1px solid ${(props) => props.theme.color.light.shade};
      &:nth-child(2n + 1) {
        background-color: rgb(250, 250, 250);
      }
      &:first-of-type {
        background-color: ${(props) => props.theme.color.blue.default};
        color: white;
        border: none;
      }
      &:last-child {
        border: none;
      }
    }
    td,
    th {
      padding: 8px 16px;
    }
  }
`;
